import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio169: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconAspectRatio169"><Path d="M2.75 5C1.7835 5 1 5.7835 1 6.75V17.25C1 18.2165 1.7835 19 2.75 19H21.25C22.2165 19 23 18.2165 23 17.25V6.75C23 5.7835 22.2165 5 21.25 5H2.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio169;
